import React, { SVGProps } from 'react'

type AddFileIconProps = SVGProps<SVGSVGElement> & {
    circleColor?: string;
    iconColor?: string;
};

const AddFileIcon = (props: AddFileIconProps) => {

    const { height = 32, width = 32, 
        circleColor = 'white', iconColor = 'black', ...rest } = props;

    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
            <g id="add file">
                <rect width={32} height={32} fill="white" />
                <g id="calender-body">
                    <rect
                        id="main-part"
                        x={2.25}
                        y={3.25}
                        width={24.5}
                        height={24.5}
                        rx={1.75}
                        stroke="black"
                        strokeWidth={0.5}
                    />
                    <path
                        id="Vector 12"
                        d="M2.5 27L9.84337 14.6081C10.1762 14.0464 10.9491 13.9491 11.4108 14.4108L13.507 16.507C13.993 16.993 14.8132 16.8551 15.1136 16.2368L18.7602 8.729C19.1138 8.00101 20.1406 7.9727 20.5338 8.6801L26 18.5152"
                        stroke="black"
                    />
                </g>
                <circle
                    id="sun"
                    cx={7}
                    cy={8}
                    r={2.75}
                    fill="#D9D9D9"
                    stroke="black"
                    strokeWidth={0.5}
                />
                <g id="circle">
                    <circle
                        id="inner-circle"
                        cx={22.5}
                        cy={22.5}
                        r={7.25}
                        fill={circleColor || "#D9D9D9"}
                        stroke={iconColor || "black"}
                        strokeWidth={0.5}
                    />
                    <path
                        id="icon"
                        d="M22.5 19V26M19 22.5H26"
                        stroke={iconColor || "black"}
                        strokeLinecap="square"
                    />
                </g>
            </g>
        </svg>
    );
}

export default AddFileIcon